import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'È una dieta?',
  a: 'No, è un sistema di organizzazione alimentare ispirato alla tradizione mediterranea.'
}, {
  q: 'Quanto tempo serve?',
  a: 'Le ricette richiedono meno di 20 min. Il Meal Prep circa 90 min a settimana.'
}, {
  q: 'Cosa ricevo?',
  a: 'Un kit digitale completo (PDF HD) consultabile da smartphone, tablet o PC.'
}, {
  q: 'È adatto ai vegetariani?',
  a: 'Sì, include tantissime opzioni a base vegetale e varianti.'
}, {
  q: 'Il pagamento è sicuro?',
  a: 'Sì, usiamo crittografia SSL avanzata per proteggere ogni transazione.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-6 sm:py-12 px-4 bg-brand-cream" data-id="element-66">
      <div className="max-w-2xl mx-auto" data-id="element-67">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-xl sm:text-3xl font-serif font-bold text-center mb-5 sm:mb-8 text-brand-text-main" data-id="element-68">
          ❓ DOMANDE FREQUENTI
        </motion.h2>

        <div className="space-y-3" data-id="element-69">
          {faqs.map((faq, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="bg-white border border-brand-gold/30 rounded-xl overflow-hidden shadow-sm" data-id="element-70">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center hover:bg-brand-sage-light transition-colors gap-4" data-id="element-71">
                <span className="font-bold text-brand-text-main text-xs sm:text-base" data-id="element-72">
                  {faq.q}
                </span>
                <ChevronDownIcon className={`w-5 h-5 text-brand-olive transition-transform duration-300 shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-73" />
              </button>

              <AnimatePresence data-id="element-74">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} data-id="element-75">
                    <div className="px-5 pb-4 pt-0 text-xs sm:text-sm text-brand-text-muted font-medium leading-relaxed" data-id="element-76">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}